module.exports = __webpack_public_path__ + "3320543fa2e0f834be4936a6b9cf1f6a.svg";